<template>
  <div class="notifications-option">
    <side-bar-item
      :description="tooltipDescription"
      :type="type"
      @click="openNotificationModal"
    >
      <template v-slot:icon="{ _class }">
        <font-awesome-icon
          slot="icon"
          :class="_class"
          :icon="['fad', 'bell']"
        />
      </template>
    </side-bar-item>
    <ModalEvents
      modal-name="CreateNotificationModal"
      :uid="createNotificationUniqueKey"
      @choice="addNotification"
    />
  </div>
</template>

<script>
import SideBarItem from './SideBarItem';
import ModalEvents from '@/components/Modals/ModalEvents';
import { mapActions } from 'vuex';

export default {
  name: 'notifications-option',
  components: {
    SideBarItem,
    ModalEvents,
  },
  props: {
    nodeId: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'diagnostic',
    },
  },
  data() {
    return {
      tooltipDescription: this.$t(
        'knowledge.article-builder.side-bar.notifications.tooltip',
      ),
    };
  },
  computed: {
    createNotificationUniqueKey() {
      return `${this.$options.name}-modal-${this.nodeId}`;
    },
  },
  methods: {
    openNotificationModal() {
      const payload = {
        component: 'CreateNotificationModal',
        uid: this.createNotificationUniqueKey,
        props: {
          open: true,
          entityId: this.nodeId,
          entityType: this.type,
          linkContent: true,
        },
      };
      this.openModal(payload);
    },
    addNotification({ notification }) {
      if (notification) {
        this.$emit('add-notification', notification);
      }
    },
    ...mapActions('modalsModule', ['openModal']),
  },
};
</script>
